module.exports = __webpack_public_path__ + "img/ic_whatsapp.80e580ac.svg";